import Icon from '@/components/common/icons';
import { FormattedMessage } from 'react-intl';
import styles from './Success.module.scss';

const Success: React.FC = () => {
  return (
    <div className={styles.container}>
      <Icon className={styles.icon} type="success" />

      <h2 className={styles.title}>
        <FormattedMessage id="contact.success.title" />
      </h2>

      <p className={styles.description}>
        <FormattedMessage id="contact.success.description" />
      </p>
    </div>
  );
};

export default Success;
